
import React, { useEffect, useState, useRef } from 'react';
import { FaBoxOpen, FaChevronLeft, FaChevronRight, FaEdit, FaPlusCircle, FaTrash } from 'react-icons/fa';
import Switch from '@mui/material/Switch';

const InventoryMaster = () => {

    // --- NEW STATES FOR CASCADE DROPDOWNS ---
    const [selectedCategory, setSelectedCategory] = useState("");
    const [selectedSubcategory, setSelectedSubcategory] = useState("");
    const [selectedVariant, setSelectedVariant] = useState(null);
    const formRef = useRef(null);
    const [block, setBlock] = useState(false); // false = 0, true = 1
    const [showForm, setShowForm] = useState(false);


    // 🔍 Search
    const [searchQuery, setSearchQuery] = useState("");
    const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });
    const [currentPage, setCurrentPage] = useState(1);
    const rowsPerPage = 10;
    const [availableSizes, setAvailableSizes] = useState([]);


    const [user, setUser] = useState(null);

    useEffect(() => {
        const stored = sessionStorage.getItem('userData');
        if (stored) {
            try {
                const parsedUser = JSON.parse(stored);
                setUser(parsedUser);
            } catch (_) { }
        }
    }, []);



    const userId = user
        ? user.type === "employee"
            ? user.parent_company_id
            : user.id
        : null;


    console.log("userId", userId)


    const currentUserId = user ? user.id : null;

    console.log("currentUserId", currentUserId)


    const [products, setProducts] = useState([]);

    useEffect(() => {
        if (userId) {
            fetchInventory();
        }
    }, [userId]);
    const fetchInventory = async () => {
        if (!userId) return;

        try {
            const res = await fetch(`https://cloudapi.emedhatechnologies.com/pages/api/api/inventory?user_id=${userId}`);
            if (!res.ok) throw new Error('Failed to fetch inventory');

            const data = await res.json();

            // Map and convert block to number
            let formatted = data.map(item => ({
                id: item.id,
                category: item.category,
                subcategory: item.subcategory || "",
                code: item.code || "",
                size: item.size || "",
                stock: item.stock || "",
                date: item.date?.split("T")[0] || "",
                variants: item.variants || [],
                block: Number(item.block),
            }));

            // 🔹 FILTER based on logged-in user
            // If currentUserId === userId → admin → show all
            // Else → show only block = 0
            if (currentUserId !== userId) {
                formatted = formatted.filter(item => item.block === 0);
            }

            setProducts(formatted);

        } catch (error) {
            console.error('Error fetching inventory:', error);
        }
    };


    const isAdmin = currentUserId === userId;


    // const fetchInventory = async () => {
    //     if (!userId) return;

    //     try {
    //         const res = await fetch(`https://cloudapi.emedhatechnologies.com/pages/api/api/inventory?user_id=${userId}`);
    //         if (!res.ok) throw new Error('Failed to fetch inventory');

    //         const data = await res.json();

    //         // Updated mapping to include subcategory, code, date, and variants if needed
    //         const formatted = data.map(item => ({
    //             id: item.id,
    //             category: item.category,
    //             subcategory: item.subcategory || "",
    //             code: item.code || "",
    //             size: item.size || "",
    //             stock: item.stock || "",
    //             date: item.date?.split("T")[0] || "",
    //             variants: item.variants || [],
    //             block: Number(item.block), // ✅ include block as number
    //         }));
    //         setProducts(formatted);

    //     } catch (error) {
    //         console.error('Error fetching inventory:', error);
    //     }
    // };
    const [formData, setFormData] = useState({
        category: "",
        subcategory: "",
        code: "",
        size: "",
        date: new Date().toISOString().split("T")[0],
        stock: "",
    });

    const handleAddProduct = async (e) => {
        e.preventDefault();

        const payload = {
            category: formData.category,
            subcategory: formData.subcategory,
            code: formData.code,
            size: formData.size,
            date: formData.date,
            stock: formData.stock,
            variant_id: formData.variant_id, // 🔹 include variant ID

            user_id: userId,          // company ID
            created_by: currentUserId,
            block: block ? 1 : 0
        };


        const url = editingId
            ? `https://cloudapi.emedhatechnologies.com/pages/api/api/inventory/${editingId}`
            : 'https://cloudapi.emedhatechnologies.com/pages/api/api/inventory';

        const method = editingId ? 'PUT' : 'POST';

        try {
            const res = await fetch(url, {
                method,
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload),
            });

            if (!res.ok) throw new Error('Failed to save product');

            setFormData({
                category: "",
                subcategory: "",
                code: "",
                size: "",
                date: new Date().toISOString().split("T")[0],
                stock: "",
            });

            setSelectedCategory("");
            setSelectedSubcategory("");
            setSelectedVariant(null);


            setEditingId(null); // reset edit state
            fetchInventory(); // refresh list
        } catch (err) {
            console.error('Save failed:', err);
            alert('Failed to save product.');
        }
    };


    const [editingId, setEditingId] = useState(null);



    const handleEdit = (product) => {
        setShowForm(true);
        setEditingId(product.id);

        setSelectedCategory(product.category);
        setSelectedSubcategory(product.subcategory);

        // Find the variant object by code & size
        const variant = productList
            .find(p => p.subcategory === product.subcategory)
            ?.variants.find(v => v.code === product.code && v.size === product.size) || null;

        setSelectedVariant(variant); // ✅ now includes variant.id

        setFormData({
            category: product.category,
            subcategory: product.subcategory,
            code: product.code,
            size: product.size,
            date: product.date?.split("T")[0] || "",
            stock: product.stock,
            variant_id: variant?.id || null // include variant ID
        });
        if (formRef.current) {
            formRef.current.scrollIntoView({ behavior: "smooth", block: "nearest" });
        }
    };


    const handleDelete = async (id) => {
        if (!window.confirm('Are you sure you want to delete this product?')) return;

        try {
            const res = await fetch(`https://cloudapi.emedhatechnologies.com/pages/api/api/ordersapi/${id}`, {
                method: 'DELETE',
            });

            if (!res.ok) throw new Error('Failed to delete');

            setProducts(prev => prev.filter(p => p.id !== id));
        } catch (err) {
            console.error('Delete failed:', err);
            alert('Failed to delete product.');
        }
    };

    const [productList, setProductList] = useState([]);

    useEffect(() => {

        if (userId) {

            fetch(`https://cloudapi.emedhatechnologies.com/pages/api/api/products/${userId}`)
                .then(res => res.json())
                .then(data => setProductList(data))
                .catch(err => console.error('Failed to load product list:', err));
        }
    }, [userId]);

    const uniqueCategories = [...new Set(productList.map(p => p.category))];

    // 🔍 Filter by search text
    const filteredProducts = products.filter(p => {
        const text = searchQuery.toLowerCase();
        return (
            p.category?.toLowerCase().includes(text) ||
            p.subcategory?.toLowerCase().includes(text) ||
            p.code?.toLowerCase().includes(text) ||
            p.size?.toLowerCase().includes(text)
        );
    });

    // 🔽 Sorting handler
    const handleSort = (key) => {
        let direction = "asc";
        if (sortConfig.key === key && sortConfig.direction === "asc") {
            direction = "desc";
        }
        setSortConfig({ key, direction });
    };

    // Apply sorting
    const sortedProducts = [...filteredProducts].sort((a, b) => {
        if (!sortConfig.key) return 0;
        const x = a[sortConfig.key];
        const y = b[sortConfig.key];
        if (x < y) return sortConfig.direction === "asc" ? -1 : 1;
        if (x > y) return sortConfig.direction === "asc" ? 1 : -1;
        return 0;
    });

    // 📄 Pagination calculations
    const indexOfLast = currentPage * rowsPerPage;
    const indexOfFirst = indexOfLast - rowsPerPage;

    const currentProducts = sortedProducts.slice(indexOfFirst, indexOfLast);

    const totalPages = Math.ceil(sortedProducts.length / rowsPerPage);



    const handleExportExcel = () => {
        if (!filteredProducts || filteredProducts.length === 0) {
            return alert("No data to export");
        }

        // 1️⃣ CSV headers matching table columns
        const headers = ["S.No", "Category", "Subcategory", "Code", "Size", "Date", "Stock"];

        // 2️⃣ Prepare CSV rows
        const rows = filteredProducts.map((product, index) => [
            index + 1,                   // S.No
            `"${product.category}"`,     // Category
            `"${product.subcategory}"`,  // Subcategory
            `"${product.code}"`,         // Code
            `"${product.size}"`,         // Size
            product.date?.split("T")[0] || "", // Date (YYYY-MM-DD)
            product.stock || 0           // Stock
        ]);

        // 3️⃣ Combine header + rows
        const csvContent = [
            headers.join(","),          // header row
            ...rows.map(r => r.join(",")) // data rows
        ].join("\n");

        // 4️⃣ Create downloadable CSV link
        const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "products.csv");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };






    // return (
    //     <div style={{ fontFamily: "Arial, sans-serif", minHeight: "100vh", color: "#222", }}>
    //         {/* TITLE */}
    //         <div>
    //             <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: "10px", marginBottom: "15px", }}>
    //                 <h3 style={{ display: "flex", alignItems: "center", gap: "8px", color: "#273179", margin: 0 }}><FaBoxOpen /> Product & Inventory Management</h3>
    //                 <button onClick={() => { setShowForm(prev => !prev); setTimeout(() => formRef.current?.scrollIntoView({ behavior: "smooth" }), 100); }} style={{ display: "flex", alignItems: "center", gap: "6px", background: "#1976d2", color: "#fff", padding: "8px 14px", fontSize: "14px", fontWeight: "500", borderRadius: "20px", border: "none", cursor: "pointer", whiteSpace: "nowrap", }}><FaPlusCircle />{showForm ? "Close Form" : "Add Inventory"}</button>
    //             </div>
    //             {showForm && (
    //                 <div ref={formRef} style={{ background: "#fff", padding: "12px", boxShadow: "0 2px 8px rgba(0,0,0,0.05)", borderRadius: "10px", marginBottom: "20px", }}>
    //                     <form onSubmit={handleAddProduct} style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(160px, 1fr))", gap: "12px", }}>
    //                         <select required value={selectedCategory} onChange={(e) => {
    //                             const cat = e.target.value;
    //                             setSelectedCategory(cat);
    //                             setSelectedSubcategory("");
    //                             setSelectedVariant(null);
    //                             setFormData(prev => ({ ...prev, category: cat, subcategory: "", code: "", size: "" }));
    //                         }} style={{ padding: "10px", fontSize: "14px", border: "1px solid #ddd", borderRadius: "6px", width: "100%", height: "42px", boxSizing: "border-box", }}>
    //                             <option value="">Select Category</option>
    //                             {uniqueCategories.map((cat, i) => (
    //                                 <option key={i} value={cat}>{cat}</option>
    //                             ))}
    //                         </select>
    //                         <select required value={selectedSubcategory} onChange={(e) => {
    //                             const sub = e.target.value;
    //                             setSelectedSubcategory(sub);
    //                             setSelectedVariant(null);
    //                             setFormData(prev => ({ ...prev, subcategory: sub, code: "", size: "" }));
    //                         }} style={{ padding: "10px", fontSize: "14px", border: "1px solid #ddd", borderRadius: "6px", width: "100%", height: "42px", boxSizing: "border-box", }}>
    //                             <option value="">Select Subcategory</option>
    //                             {productList.filter(p => p.category === selectedCategory).map(p => (
    //                                 <option key={p.id} value={p.subcategory}>{p.subcategory}</option>
    //                             ))}
    //                         </select>
    //                         <select required value={formData.code} onChange={(e) => {
    //                             const code = e.target.value;
    //                             const variants = productList.find(p => p.subcategory === selectedSubcategory)?.variants || [];
    //                             const variant = variants.find(v => v.code === code);
    //                             setSelectedVariant(variant || null);
    //                             setFormData(prev => ({ ...prev, code, size: variant?.size || "", variant_id: variant?.id || null }));
    //                             setAvailableSizes(variants.filter(v => v.code === code).map(v => v.size));
    //                         }} style={{ padding: "10px", fontSize: "14px", border: "1px solid #ddd", borderRadius: "6px", width: "100%", height: "42px", boxSizing: "border-box", }}>
    //                             <option value="">Select Code</option>
    //                             {[...new Set(
    //                                 (productList.find(p => p.subcategory === selectedSubcategory)?.variants || []).map(v => v.code)
    //                             )].map(code => (
    //                                 <option key={code} value={code}>{code}</option>
    //                             ))}
    //                         </select>
    //                         <select required value={formData.size} onChange={(e) => {
    //                             const size = e.target.value;
    //                             const variants = productList.find(p => p.subcategory === selectedSubcategory)?.variants || [];
    //                             const variant = variants.find(v => v.code === formData.code && v.size === size);
    //                             setSelectedVariant(variant || null);
    //                             setFormData(prev => ({ ...prev, size, variant_id: variant?.id || null }));
    //                         }} style={{ padding: "10px", fontSize: "14px", border: "1px solid #ddd", borderRadius: "6px", width: "100%", height: "42px", boxSizing: "border-box", }}>
    //                             <option value="">Select Size</option>
    //                             {availableSizes?.map((s, i) => (
    //                                 <option key={i} value={s}>{s}</option>
    //                             ))}
    //                         </select>
    //                         <input type="date" required value={formData.date} onChange={(e) => setFormData(prev => ({ ...prev, date: e.target.value }))} style={{ padding: "10px", fontSize: "14px", border: "1px solid #ddd", borderRadius: "6px", width: "100%", height: "42px", boxSizing: "border-box", }} />
    //                         <input type="number" required placeholder="Stock" value={formData.stock} onChange={(e) => setFormData(prev => ({ ...prev, stock: e.target.value }))} style={{ padding: "10px", fontSize: "14px", border: "1px solid #ddd", borderRadius: "6px", width: "100%", height: "42px", boxSizing: "border-box", }} />
    //                         <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
    //                             <strong>Block</strong>
    //                             <Switch checked={block} onChange={(e) => setBlock(e.target.checked)} />
    //                         </div>
    //                         <button type="submit" style={{ gridColumn: "span 2", background: "#1976d2", color: "#fff", border: "none", borderRadius: "8px", padding: "10px", cursor: "pointer", fontWeight: 500, }}>{editingId ? "Update Inventory" : "Add Inventory"}</button>
    //                     </form>
    //                 </div>
    //             )}


    //             {/* <div ref={formRef} style={{ background: "#fff", padding: "10px", boxShadow: "0 2px 8px rgba(0,0,0,0.05)", marginBottom: "20px", }}>
    //                 <form onSubmit={handleAddProduct} style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(150px, 1fr))", gap: "10px", }}>
                   
    //                     <select
    //                         value={selectedCategory}
    //                         onChange={(e) => {
    //                             const cat = e.target.value;
    //                             setSelectedCategory(cat);
    //                             setSelectedSubcategory("");
    //                             setSelectedVariant(null);
    //                             setFormData(prev => ({
    //                                 ...prev,
    //                                 category: cat,
    //                                 subcategory: "",
    //                                 code: "",
    //                                 size: "",
    //                             }));
    //                         }}
    //                         required style={{ padding: "10px", fontSize: "14px", border: "1px solid #ddd", borderRadius: "6px", width: "100%", boxSizing: "border-box", height: "42px", }}
    //                     >
    //                         <option value="">Select Category</option>
    //                         {uniqueCategories.map((cat, i) => (
    //                             <option key={i} value={cat}>{cat}</option>
    //                         ))}
    //                     </select>

    //                     <select
    //                         value={selectedSubcategory}
    //                         onChange={(e) => {
    //                             const sub = e.target.value;
    //                             setSelectedSubcategory(sub);
    //                             setSelectedVariant(null);
    //                             setFormData(prev => ({
    //                                 ...prev,
    //                                 subcategory: sub,
    //                                 code: "",
    //                                 size: "",
    //                             }));
    //                         }}
    //                         required style={{ padding: "10px", fontSize: "14px", border: "1px solid #ddd", borderRadius: "6px", width: "100%", boxSizing: "border-box", height: "42px", }}>
    //                         <option value="">Select Subcategory</option>
    //                         {productList.filter(p => p.category === selectedCategory).map(p => (
    //                             <option key={p.id} value={p.subcategory}>{p.subcategory}</option>
    //                         ))}
    //                     </select>
    //                     <select
    //                         value={formData.code}
    //                         onChange={(e) => {
    //                             const code = e.target.value;
    //                             const variants = productList.find(p => p.subcategory === selectedSubcategory)?.variants || [];
    //                             const variant = variants.find(v => v.code === code);
    //                             setSelectedVariant(variant || null);
    //                             setFormData(prev => ({
    //                                 ...prev,
    //                                 code,
    //                                 size: variant?.size || "",
    //                                 variant_id: variant?.id || null,
    //                             }));
    //                             setAvailableSizes(variants.filter(v => v.code === code).map(v => v.size));
    //                         }}
    //                         required style={{ padding: "10px", fontSize: "14px", border: "1px solid #ddd", borderRadius: "6px", width: "100%", boxSizing: "border-box", height: "42px", }}
    //                     >
    //                         <option value="">Select Code</option>
    //                         {[...new Set(
    //                             (productList.find(p => p.subcategory === selectedSubcategory)?.variants || []).map(v => v.code)
    //                         )].map(code => (
    //                             <option key={code} value={code}>{code}</option>
    //                         ))}
    //                     </select>
    //                     <select
    //                         value={formData.size}
    //                         onChange={(e) => {
    //                             const size = e.target.value;
    //                             const variants = productList.find(p => p.subcategory === selectedSubcategory)?.variants || [];
    //                             const variant = variants.find(v => v.code === formData.code && v.size === size);
    //                             setSelectedVariant(variant || null);
    //                             setFormData(prev => ({ ...prev, size, variant_id: variant?.id || null }));
    //                         }}
    //                         required
    //                         style={{ padding: "10px", fontSize: "14px", border: "1px solid #ddd", borderRadius: "6px", width: "100%", boxSizing: "border-box", height: "42px", }}>
    //                         <option value="">Select Size</option>
    //                         {availableSizes?.map((s, i) => (
    //                             <option key={i} value={s}>{s}</option>
    //                         ))}
    //                     </select>
    //                     <input type="date" name="date" value={formData.date} onChange={(e) => setFormData(prev => ({ ...prev, date: e.target.value }))} required style={{ padding: "10px", fontSize: "14px", border: "1px solid #ddd", borderRadius: "6px", width: "100%", boxSizing: "border-box", height: "42px", }} />
    //                     <input type="number" name="stock" placeholder="Stock" value={formData.stock} onChange={(e) => setFormData(prev => ({ ...prev, stock: e.target.value }))} required style={{ padding: "10px", fontSize: "14px", border: "1px solid #ddd", borderRadius: "6px", width: "100%", boxSizing: "border-box", height: "42px", }} />
    //                     <div style={{ display: "flex", alignItems: "center", gap: "8px", marginBottom: "12px" }}>
    //                         <label style={{ fontSize: "14px", fontWeight: "500" }}>Block</label>
    //                         <Switch
    //                             checked={block}
    //                             onChange={(e) => setBlock(e.target.checked)}
    //                             color="primary"
    //                         />
    //                     </div>
    //                     <button type="submit" style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "6px", background: "#1976d2", color: "#fff", padding: "10px", fontSize: "14px", fontWeight: "500", borderRadius: "6px", border: "none", cursor: "pointer", height: "42px", }}>
    //                         <FaPlusCircle />
    //                         {editingId ? "Update Entry" : "Add Entry"}
    //                     </button>
    //                 </form>
    //             </div> */}
    //         </div>

    //         <div style={{ boxShadow: "0 2px 8px rgba(0,0,0,0.05)", }}>
    //             <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "12px", gap: "12px" }}>
    //                 <input type="text" placeholder="Search category, subcategory, code..." value={searchQuery} onChange={e => { setSearchQuery(e.target.value); setCurrentPage(1); }} style={{ flex: 1, padding: "6px 10px", borderRadius: "10px", border: "1px solid #ccc", maxWidth: "600px", }} />
    //                 <button style={{ padding: "6px 12px", borderRadius: "5px", cursor: "pointer" }} onClick={handleExportExcel}>Export Excel</button>
    //             </div>
    //             {/* <div style={{ overflowX: "auto", width: "100%" }}>
    //                 <table style={{ width: "100%", borderCollapse: "collapse", minWidth: "600px", fontSize: "14px" }}>
    //                     <thead>
    //                         <tr>
    //                             {["category", "subcategory", "code", "size", "date", "stock"].map(col => (
    //                                 <th key={col} onClick={() => handleSort(col)} style={{ textAlign: "left", padding: "12px", borderBottom: "2px solid #ddd", background: "#f5f5f5", cursor: "pointer", userSelect: "none", whiteSpace: "nowrap" }}>
    //                                     {col.charAt(0).toUpperCase() + col.slice(1)}
    //                                     {sortConfig.key === col && (sortConfig.direction === "asc" ? " ↑" : " ↓")}
    //                                 </th>
    //                             ))}
    //                             {isAdmin && <th style={{ textAlign: "left", padding: "12px", borderBottom: "2px solid #ddd", background: "#f5f5f5", whiteSpace: "nowrap" }}>Block</th>}
    //                             <th style={{ textAlign: "left", padding: "12px", borderBottom: "2px solid #ddd", background: "#f5f5f5", whiteSpace: "nowrap" }}>Actions</th>
    //                         </tr>
    //                     </thead>
    //                     <tbody>
    //                         {currentProducts.map(product => (
    //                             <tr key={product.id}>
    //                                 <td style={{ padding: "10px", borderBottom: "1px solid #eee" }}>{product.category}</td>
    //                                 <td style={{ padding: "10px", borderBottom: "1px solid #eee" }}>{product.subcategory}</td>
    //                                 <td style={{ padding: "10px", borderBottom: "1px solid #eee" }}>{product.code}</td>
    //                                 <td style={{ padding: "10px", borderBottom: "1px solid #eee" }}>{product.size}</td>
    //                                 <td style={{ padding: "10px", borderBottom: "1px solid #eee" }}>{product.date?.split("T")[0]}</td>
    //                                 <td style={{ padding: "10px", borderBottom: "1px solid #eee" }}>{product.stock}</td>
    //                                 {isAdmin && (
    //                                     <td style={{ padding: "10px", borderBottom: "1px solid #eee" }}>
    //                                         <Switch
    //                                             checked={product.block === 1}
    //                                             color="primary"
    //                                             onChange={async (e) => {
    //                                                 const newBlock = e.target.checked ? 1 : 0;

    //                                                 try {
    //                                                     await fetch(`https://cloudapi.emedhatechnologies.com/pages/api/api/inventory/block/${product.id}`, {
    //                                                         method: 'PATCH',
    //                                                         headers: { 'Content-Type': 'application/json' },
    //                                                         body: JSON.stringify({ block: newBlock, updated_by: currentUserId }),
    //                                                     });                                          
    //                                                     setProducts(prev =>
    //                                                         prev.map(p => p.id === product.id ? { ...p, block: newBlock } : p)
    //                                                     );
    //                                                 } catch (err) {
    //                                                     console.error('Failed to update block:', err);
    //                                                     alert('Failed to update block status');
    //                                                 }
    //                                             }}
    //                                         />
    //                                     </td>
    //                                 )}
    //                                 <td style={{ padding: "10px", borderBottom: "1px solid #eee" }}>
    //                                     <button onClick={() => handleEdit(product)} style={{ marginRight: "6px", color: "#02adf0", background: "none", border: "none", cursor: "pointer" }}><FaEdit /></button>
    //                                     <button style={{ color: "gray", opacity: 0.6, cursor: "not-allowed", background: "none", border: "none" }} disabled><FaTrash /></button>
    //                                 </td>
    //                             </tr>
    //                         ))}
    //                     </tbody>
    //                 </table>
    //             </div> */}
    //             <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
    //                 {currentProducts.map((product, index) => (
    //                     <div key={product.id} style={{ border: "1px solid #ddd", borderRadius: "10px", padding: "12px", background: "#fff", boxShadow: "0 2px 6px rgba(0,0,0,0.08)", }}>
    //                         {/* ROW 1 */}
    //                         <div style={{ display: "flex", justifyContent: "space-between", flexWrap: "wrap", marginBottom: "6px" }}>
    //                             <div><strong>Category:</strong> {product.category}</div>
    //                             <div><strong>Subcategory:</strong> {product.subcategory}</div>
    //                         </div>

    //                         {/* ROW 2 */}
    //                         <div style={{ display: "flex", justifyContent: "space-between", flexWrap: "wrap", marginBottom: "6px" }}>
    //                             <div><strong>Code:</strong> {product.code}</div>
    //                             <div><strong>Size:</strong> {product.size}</div>
    //                         </div>

    //                         {/* ROW 3 */}
    //                         <div style={{ display: "flex", justifyContent: "space-between", flexWrap: "wrap", marginBottom: "6px" }}>
    //                             <div><strong>Date:</strong> {product.date?.split("T")[0]}</div>
    //                             <div><strong>Stock:</strong> {product.stock}</div>
    //                         </div>

    //                         {/* ADMIN BLOCK */}
    //                         {isAdmin && (
    //                             <div style={{ display: "flex", alignItems: "center", gap: "8px", marginBottom: "6px" }}>
    //                                 <strong>Block:</strong>
    //                                 <Switch
    //                                     checked={product.block === 1}
    //                                     color="primary"
    //                                     onChange={async (e) => {
    //                                         const newBlock = e.target.checked ? 1 : 0;
    //                                         try {
    //                                             await fetch(
    //                                                 `https://cloudapi.emedhatechnologies.com/pages/api/api/inventory/block/${product.id}`,
    //                                                 {
    //                                                     method: "PATCH",
    //                                                     headers: { "Content-Type": "application/json" },
    //                                                     body: JSON.stringify({ block: newBlock, updated_by: currentUserId }),
    //                                                 }
    //                                             );

    //                                             setProducts(prev =>
    //                                                 prev.map(p => p.id === product.id ? { ...p, block: newBlock } : p)
    //                                             );
    //                                         } catch {
    //                                             alert("Failed to update block status");
    //                                         }
    //                                     }}
    //                                 />
    //                             </div>
    //                         )}

    //                         {/* ACTIONS */}
    //                         <div style={{ display: "flex", gap: "10px", marginTop: "8px" }}>
    //                             <button onClick={() => handleEdit(product)} style={{ background: "#e3f2fd", border: "none", padding: "6px 10px", borderRadius: "50px", cursor: "pointer", color: "#1976d2", }}><FaEdit size={14} /></button>
    //                             <button disable dstyle={{ background: "#eee", border: "none", padding: "6px 10px", borderRadius: "50px", cursor: "not-allowed", color: "#888", }}><FaTrash size={14} /></button>
    //                         </div>
    //                     </div>
    //                 ))}
    //             </div>


    //             <div style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: "10px", marginTop: "15px", fontSize: "13px" }}>
    //                 <button disabled={currentPage === 1 || totalPages === 0} onClick={() => setCurrentPage(currentPage - 1)} style={{ background: "#1976d2", color: "#fff", border: "none", borderRadius: "50%", padding: "5px", cursor: currentPage === 1 || totalPages === 0 ? "not-allowed" : "pointer", }}><FaChevronLeft /></button>
    //                 <span>Page {totalPages > 0 ? currentPage : 0} / {totalPages}</span>
    //                 <button disabled={currentPage === totalPages || totalPages === 0} onClick={() => setCurrentPage(currentPage + 1)} style={{ background: "#1976d2", color: "#fff", border: "none", borderRadius: "50%", padding: "5px", cursor: currentPage === totalPages || totalPages === 0 ? "not-allowed" : "pointer", }}><FaChevronRight /></button>
    //             </div>
    //         </div>
    //     </div>

    // );

return (
    <div style={{ fontFamily: "'Poppins', 'Segoe UI', Arial, sans-serif", minHeight: "100vh", color: "#333", backgroundColor: "#f8fafc"}}>
        {/* TITLE SECTION */}
        <div style={{ background: "#fff", padding: "20px 24px", borderRadius: "16px", boxShadow: "0 4px 20px rgba(0,0,0,0.02)", border: "1px solid #edf2f7", marginBottom: "24px" }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: "16px" }}>
                <h3 style={{ display: "flex", alignItems: "center", gap: "12px", color: "#1e293b", margin: 0, fontSize: "22px", fontWeight: "600" }}>
                    <FaBoxOpen style={{ color: "#4f46e5" }} /> Product & Inventory Management
                </h3>
                <button 
                    onClick={() => { setShowForm(prev => !prev); setTimeout(() => formRef.current?.scrollIntoView({ behavior: "smooth" }), 100); }} 
                    style={{ display: "flex", alignItems: "center", gap: "8px", background: showForm ? "#ef4444" : "#4f46e5", color: "#fff", padding: "10px 20px", fontSize: "14px", fontWeight: "600", borderRadius: "10px", border: "none", cursor: "pointer", whiteSpace: "nowrap", transition: "all 0.2s ease", boxShadow: "0 4px 12px rgba(79, 70, 229, 0.15)" }}
                >
                    <FaPlusCircle />{showForm ? "Close Form" : "Add Inventory"}
                </button>
            </div>

            {/* FORM CONTAINER */}
            {showForm && (
                <div ref={formRef} style={{ background: "#fff", padding: "24px", border: "1px solid #e2e8f0", borderRadius: "12px", marginTop: "20px", boxShadow: "0 10px 25px rgba(0,0,0,0.03)" }}>
                    <form onSubmit={handleAddProduct} style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))", gap: "16px", alignItems: "end" }}>
                        
                        <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
                            <label style={{ fontSize: "13px", fontWeight: "600", color: "#64748b" }}>Category</label>
                            <select required value={selectedCategory} onChange={(e) => {
                                const cat = e.target.value;
                                setSelectedCategory(cat);
                                setSelectedSubcategory("");
                                setSelectedVariant(null);
                                setFormData(prev => ({ ...prev, category: cat, subcategory: "", code: "", size: "" }));
                            }} style={{ padding: "11px 14px", fontSize: "14px", border: "1px solid #cbd5e1", borderRadius: "8px", width: "100%", height: "44px", boxSizing: "border-box", backgroundColor: "#f8fafc", color: "#334155", outline: "none" }}>
                                <option value="">Select Category</option>
                                {uniqueCategories.map((cat, i) => (
                                    <option key={i} value={cat}>{cat}</option>
                                ))}
                            </select>
                        </div>

                        <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
                            <label style={{ fontSize: "13px", fontWeight: "600", color: "#64748b" }}>Subcategory</label>
                            <select required value={selectedSubcategory} onChange={(e) => {
                                const sub = e.target.value;
                                setSelectedSubcategory(sub);
                                setSelectedVariant(null);
                                setFormData(prev => ({ ...prev, subcategory: sub, code: "", size: "" }));
                            }} style={{ padding: "11px 14px", fontSize: "14px", border: "1px solid #cbd5e1", borderRadius: "8px", width: "100%", height: "44px", boxSizing: "border-box", backgroundColor: "#f8fafc", color: "#334155", outline: "none" }}>
                                <option value="">Select Subcategory</option>
                                {productList.filter(p => p.category === selectedCategory).map(p => (
                                    <option key={p.id} value={p.subcategory}>{p.subcategory}</option>
                                ))}
                            </select>
                        </div>

                        <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
                            <label style={{ fontSize: "13px", fontWeight: "600", color: "#64748b" }}>Code</label>
                            <select required value={formData.code} onChange={(e) => {
                                const code = e.target.value;
                                const variants = productList.find(p => p.subcategory === selectedSubcategory)?.variants || [];
                                const variant = variants.find(v => v.code === code);
                                setSelectedVariant(variant || null);
                                setFormData(prev => ({ ...prev, code, size: variant?.size || "", variant_id: variant?.id || null }));
                                setAvailableSizes(variants.filter(v => v.code === code).map(v => v.size));
                            }} style={{ padding: "11px 14px", fontSize: "14px", border: "1px solid #cbd5e1", borderRadius: "8px", width: "100%", height: "44px", boxSizing: "border-box", backgroundColor: "#f8fafc", color: "#334155", outline: "none" }}>
                                <option value="">Select Code</option>
                                {[...new Set(
                                    (productList.find(p => p.subcategory === selectedSubcategory)?.variants || []).map(v => v.code)
                                )].map(code => (
                                    <option key={code} value={code}>{code}</option>
                                ))}
                            </select>
                        </div>

                        <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
                            <label style={{ fontSize: "13px", fontWeight: "600", color: "#64748b" }}>Size</label>
                            <select required value={formData.size} onChange={(e) => {
                                const size = e.target.value;
                                const variants = productList.find(p => p.subcategory === selectedSubcategory)?.variants || [];
                                const variant = variants.find(v => v.code === formData.code && v.size === size);
                                setSelectedVariant(variant || null);
                                setFormData(prev => ({ ...prev, size, variant_id: variant?.id || null }));
                            }} style={{ padding: "11px 14px", fontSize: "14px", border: "1px solid #cbd5e1", borderRadius: "8px", width: "100%", height: "44px", boxSizing: "border-box", backgroundColor: "#f8fafc", color: "#334155", outline: "none" }}>
                                <option value="">Select Size</option>
                                {availableSizes?.map((s, i) => (
                                    <option key={i} value={s}>{s}</option>
                                ))}
                            </select>
                        </div>

                        <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
                            <label style={{ fontSize: "13px", fontWeight: "600", color: "#64748b" }}>Date</label>
                            <input type="date" required value={formData.date} onChange={(e) => setFormData(prev => ({ ...prev, date: e.target.value }))} style={{ padding: "11px 14px", fontSize: "14px", border: "1px solid #cbd5e1", borderRadius: "8px", width: "100%", height: "44px", boxSizing: "border-box", backgroundColor: "#f8fafc", color: "#334155", outline: "none" }} />
                        </div>

                        <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
                            <label style={{ fontSize: "13px", fontWeight: "600", color: "#64748b" }}>Stock Quantity</label>
                            <input type="number" required placeholder="Stock" value={formData.stock} onChange={(e) => setFormData(prev => ({ ...prev, stock: e.target.value }))} style={{ padding: "11px 14px", fontSize: "14px", border: "1px solid #cbd5e1", borderRadius: "8px", width: "100%", height: "44px", boxSizing: "border-box", backgroundColor: "#f8fafc", color: "#334155", outline: "none" }} />
                        </div>

                        <div style={{ display: "flex", alignItems: "center", gap: "10px", height: "44px", background: "#f1f5f9", padding: "0 16px", borderRadius: "8px", border: "1px dashed #cbd5e1", width: "fit-content", boxSizing: "border-box" }}>
                            <strong style={{ fontSize: "14px", color: "#475569" }}>Block Status</strong>
                            <Switch checked={block} onChange={(e) => setBlock(e.target.checked)} />
                        </div>

                        <button type="submit" style={{ gridColumn: "1 / -1", background: "#10b981", color: "#fff", border: "none", borderRadius: "8px", padding: "12px", cursor: "pointer", fontWeight: "600", fontSize: "15px", boxShadow: "0 4px 12px rgba(16, 185, 129, 0.2)", transition: "background 0.2s" }}>
                            {editingId ? "Update Inventory Details" : "Save New Inventory Entry"}
                        </button>
                    </form>
                </div>
            )}
        </div>

        {/* DATA CONTAINER AREA */}
        <div style={{ background: "#fff", padding: "24px", borderRadius: "16px", boxShadow: "0 4px 20px rgba(0,0,0,0.02)", border: "1px solid #edf2f7" }}>
            
            {/* SEARCH AND ACTION BAR */}
            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "20px", gap: "16px", flexWrap: "wrap" }}>
                <input 
                    type="text" 
                    placeholder="Search category, subcategory, code..." 
                    value={searchQuery} 
                    onChange={e => { setSearchQuery(e.target.value); setCurrentPage(1); }} 
                    style={{ flex: 1, padding: "12px 16px", borderRadius: "10px", border: "1px solid #cbd5e1", maxWidth: "450px", fontSize: "14px", outline: "none", backgroundColor: "#f8fafc" }} 
                />
                <button style={{ padding: "12px 24px", borderRadius: "10px", cursor: "pointer", background: "#fff", border: "1px solid #cbd5e1", color: "#475569", fontWeight: "600", fontSize: "14px", display: "flex", alignItems: "center", gap: "8px", boxShadow: "0 2px 4px rgba(0,0,0,0.02)" }} onClick={handleExportExcel}>
                    Export Excel
                </button>
            </div>

            {/* PRODUCT DYNAMIC CARDS LIST */}
            <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
                {currentProducts.map((product, index) => (
                    <div key={product.id} style={{ border: "1px solid #e2e8f0", borderRadius: "12px", padding: "16px 20px", background: "#fff", boxShadow: "0 4px 6px -1px rgba(0,0,0,0.02), 0 2px 4px -1px rgba(0,0,0,0.01)", display: "flex", flexDirection: "column", gap: "12px" }}>
                        
                        {/* LINE 1: BADGES LAYOUT */}
                        <div style={{ display: "flex", justifyContent: "space-between", flexWrap: "wrap", alignItems: "center", gap: "12px", borderBottom: "1px solid #f1f5f9", paddingBottom: "10px" }}>
                            <div style={{ display: "flex", gap: "8px", flexWrap: "wrap" }}>
                                <span style={{ background: "#e0e7ff", color: "#4338ca", padding: "4px 12px", borderRadius: "6px", fontSize: "13px", fontWeight: "600" }}>
                                    {product.category}
                                </span>
                                <span style={{ background: "#f1f5f9", color: "#334155", padding: "4px 12px", borderRadius: "6px", fontSize: "13px", fontWeight: "500" }}>
                                    {product.subcategory}
                                </span>
                            </div>
                            
                            {/* TOP-RIGHT ACTIONS */}
                            <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                                {isAdmin && (
                                    <div style={{ display: "flex", alignItems: "center", gap: "6px", background: "#f8fafc", padding: "4px 10px", borderRadius: "20px", border: "1px solid #e2e8f0" }}>
                                        <span style={{ fontSize: "12px", fontWeight: "600", color: "#64748b" }}>Block:</span>
                                        <Switch
                                            checked={product.block === 1}
                                            color="primary"
                                            onChange={async (e) => {
                                                const newBlock = e.target.checked ? 1 : 0;
                                                try {
                                                    await fetch(
                                                        `https://cloudapi.emedhatechnologies.com/pages/api/api/inventory/block/${product.id}`,
                                                        {
                                                            method: "PATCH",
                                                            headers: { "Content-Type": "application/json" },
                                                            body: JSON.stringify({ block: newBlock, updated_by: currentUserId }),
                                                        }
                                                    );
                                                    setProducts(prev =>
                                                        prev.map(p => p.id === product.id ? { ...p, block: newBlock } : p)
                                                    );
                                                } catch {
                                                    alert("Failed to update block status");
                                                }
                                            }}
                                        />
                                    </div>
                                )}
                                <div style={{ display: "flex", gap: "6px" }}>
                                    <button onClick={() => handleEdit(product)} style={{ background: "#eff6ff", border: "none", padding: "8px 12px", borderRadius: "8px", cursor: "pointer", color: "#2563eb", display: "flex", alignItems: "center", justifyContent: "center" }}><FaEdit size={15} /></button>
                                    <button disabled style={{ background: "#f1f5f9", border: "none", padding: "8px 12px", borderRadius: "8px", cursor: "not-allowed", color: "#94a3b8", display: "flex", alignItems: "center", justifyContent: "center" }}><FaTrash size={15} /></button>
                                </div>
                            </div>
                        </div>

                        {/* LINE 2: SPECIFICATIONS DATA GRID */}
                        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(140px, 1fr))", gap: "16px", background: "#f8fafc", padding: "12px 16px", borderRadius: "8px" }}>
                            <div>
                                <div style={{ fontSize: "11px", color: "#64748b", fontWeight: "600", textTransform: "uppercase", marginBottom: "2px" }}>Code</div>
                                <div style={{ fontSize: "14px", fontWeight: "600", color: "#1e293b" }}>{product.code}</div>
                            </div>
                            <div>
                                <div style={{ fontSize: "11px", color: "#64748b", fontWeight: "600", textTransform: "uppercase", marginBottom: "2px" }}>Size</div>
                                <div style={{ fontSize: "14px", fontWeight: "600", color: "#1e293b" }}>{product.size}</div>
                            </div>
                            <div>
                                <div style={{ fontSize: "11px", color: "#64748b", fontWeight: "600", textTransform: "uppercase", marginBottom: "2px" }}>Date Changed</div>
                                <div style={{ fontSize: "14px", fontWeight: "500", color: "#475569" }}>{product.date?.split("T")[0]}</div>
                            </div>
                            <div>
                                <div style={{ fontSize: "11px", color: "#64748b", fontWeight: "600", textTransform: "uppercase", marginBottom: "2px" }}>Stock Status</div>
                                <div style={{ fontSize: "14px", fontWeight: "700", color: parseInt(product.stock) > 5 ? "#059669" : "#d97706" }}>{product.stock} Units</div>
                            </div>
                        </div>

                    </div>
                ))}
            </div>

            {/* PAGINATION TOOL BAR */}
            <div style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: "16px", marginTop: "24px", paddingTop: "16px", borderTop: "1px solid #f1f5f9" }}>
                <button 
                    disabled={currentPage === 1 || totalPages === 0} 
                    onClick={() => setCurrentPage(currentPage - 1)} 
                    style={{ background: currentPage === 1 || totalPages === 0 ? "#e2e8f0" : "#4f46e5", color: currentPage === 1 || totalPages === 0 ? "#94a3b8" : "#fff", border: "none", borderRadius: "50%", width: "36px", height: "36px", display: "flex", alignItems: "center", justifyContent: "center", cursor: currentPage === 1 || totalPages === 0 ? "not-allowed" : "pointer", boxShadow: "0 2px 4px rgba(0,0,0,0.05)" }}
                >
                    <FaChevronLeft />
                </button>
                <span style={{ fontSize: "14px", fontWeight: "600", color: "#475569" }}>
                    Page {totalPages > 0 ? currentPage : 0} of {totalPages}
                </span>
                <button 
                    disabled={currentPage === totalPages || totalPages === 0} 
                    onClick={() => setCurrentPage(currentPage + 1)} 
                    style={{ background: currentPage === totalPages || totalPages === 0 ? "#e2e8f0" : "#4f46e5", color: currentPage === totalPages || totalPages === 0 ? "#94a3b8" : "#fff", border: "none", borderRadius: "50%", width: "36px", height: "36px", display: "flex", alignItems: "center", justifyContent: "center", cursor: currentPage === totalPages || totalPages === 0 ? "not-allowed" : "pointer", boxShadow: "0 2px 4px rgba(0,0,0,0.05)" }}
                >
                    <FaChevronRight />
                </button>
            </div>
        </div>
    </div>
);
};

export default InventoryMaster;



// import React, { useEffect, useState, useRef } from 'react';
// import { FaBoxOpen, FaChevronLeft, FaChevronRight, FaEdit, FaPlusCircle, FaTrash } from 'react-icons/fa';
// import Switch from '@mui/material/Switch';

// const InventoryMaster = () => {

//     // --- NEW STATES FOR CASCADE DROPDOWNS ---
//     const [selectedCategory, setSelectedCategory] = useState("");
//     const [selectedSubcategory, setSelectedSubcategory] = useState("");
//     const [selectedVariant, setSelectedVariant] = useState(null);
//     const formRef = useRef(null);
//     const [block, setBlock] = useState(false); // false = 0, true = 1
//     const [showForm, setShowForm] = useState(false);


//     // 🔍 Search
//     const [searchQuery, setSearchQuery] = useState("");
//     const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });
//     const [currentPage, setCurrentPage] = useState(1);
//     const rowsPerPage = 10;
//     const [availableSizes, setAvailableSizes] = useState([]);


//     const [user, setUser] = useState(null);

//     useEffect(() => {
//         const stored = sessionStorage.getItem('userData');
//         if (stored) {
//             try {
//                 const parsedUser = JSON.parse(stored);
//                 setUser(parsedUser);
//             } catch (_) { }
//         }
//     }, []);



//     const userId = user
//         ? user.type === "employee"
//             ? user.parent_company_id
//             : user.id
//         : null;


//     console.log("userId", userId)


//     const currentUserId = user ? user.id : null;

//     console.log("currentUserId", currentUserId)


//     const [products, setProducts] = useState([]);

//     useEffect(() => {
//         if (userId) {
//             fetchInventory();
//         }
//     }, [userId]);

//     const fetchInventory = async () => {
//         if (!userId) return;

//         try {
//             const res = await fetch(`https://cloudapi.emedhatechnologies.com/pages/api/api/inventory?user_id=${userId}`);
//             if (!res.ok) throw new Error('Failed to fetch inventory');

//             const data = await res.json();

//             // Map and convert block to number
//             let formatted = data.map(item => ({
//                 id: item.id,
//                 category: item.category,
//                 subcategory: item.subcategory || "",
//                 code: item.code || "",
//                 size: item.size || "",
//                 stock: item.stock || "",
//                 date: item.date?.split("T")[0] || "",
//                 variants: item.variants || [],
//                 block: Number(item.block),
//             }));

//             // 🔹 FILTER based on logged-in user
//             // If currentUserId === userId → admin → show all
//             // Else → show only block = 0
//             if (currentUserId !== userId) {
//                 formatted = formatted.filter(item => item.block === 0);
//             }

//             setProducts(formatted);

//         } catch (error) {
//             console.error('Error fetching inventory:', error);
//         }
//     };


//     const isAdmin = currentUserId === userId;

//     const [formData, setFormData] = useState({
//         category: "",
//         subcategory: "",
//         code: "",
//         size: "",
//         date: new Date().toISOString().split("T")[0],
//         stock: "",
//     });

//     const handleAddProduct = async (e) => {
//         e.preventDefault();

//         const payload = {
//             category: formData.category,
//             subcategory: formData.subcategory,
//             code: formData.code,
//             size: formData.size,
//             date: formData.date,
//             stock: formData.stock,
//             variant_id: formData.variant_id, // 🔹 include variant ID

//             user_id: userId,          // company ID
//             created_by: currentUserId,
//             block: block ? 1 : 0
//         };


//         const url = editingId
//             ? `https://cloudapi.emedhatechnologies.com/pages/api/api/inventory/${editingId}`
//             : 'https://cloudapi.emedhatechnologies.com/pages/api/api/inventory';

//         const method = editingId ? 'PUT' : 'POST';

//         try {
//             const res = await fetch(url, {
//                 method,
//                 headers: { 'Content-Type': 'application/json' },
//                 body: JSON.stringify(payload),
//             });

//             if (!res.ok) throw new Error('Failed to save product');

//             setFormData({
//                 category: "",
//                 subcategory: "",
//                 code: "",
//                 size: "",
//                 date: new Date().toISOString().split("T")[0],
//                 stock: "",
//             });

//             setSelectedCategory("");
//             setSelectedSubcategory("");
//             setSelectedVariant(null);


//             setEditingId(null); // reset edit state
//             fetchInventory(); // refresh list
//         } catch (err) {
//             console.error('Save failed:', err);
//             alert('Failed to save product.');
//         }
//     };


//     const [editingId, setEditingId] = useState(null);



//     const handleEdit = (product) => {
//         setShowForm(true);
//         setEditingId(product.id);

//         setSelectedCategory(product.category);
//         setSelectedSubcategory(product.subcategory);

//         // Find the variant object by code & size
//         const variant = productList
//             .find(p => p.subcategory === product.subcategory)
//             ?.variants.find(v => v.code === product.code && v.size === product.size) || null;

//         setSelectedVariant(variant); // ✅ now includes variant.id

//         setFormData({
//             category: product.category,
//             subcategory: product.subcategory,
//             code: product.code,
//             size: product.size,
//             date: product.date?.split("T")[0] || "",
//             stock: product.stock,
//             variant_id: variant?.id || null // include variant ID
//         });
//         if (formRef.current) {
//             formRef.current.scrollIntoView({ behavior: "smooth", block: "nearest" });
//         }
//     };


//     const handleDelete = async (id) => {
//         if (!window.confirm('Are you sure you want to delete this product?')) return;

//         try {
//             const res = await fetch(`https://cloudapi.emedhatechnologies.com/pages/api/api/ordersapi/${id}`, {
//                 method: 'DELETE',
//             });

//             if (!res.ok) throw new Error('Failed to delete');

//             setProducts(prev => prev.filter(p => p.id !== id));
//         } catch (err) {
//             console.error('Delete failed:', err);
//             alert('Failed to delete product.');
//         }
//     };

//     const [productList, setProductList] = useState([]);

//     useEffect(() => {
//         if (userId) {
//             fetch(`https://cloudapi.emedhatechnologies.com/pages/api/api/products/${userId}`)
//                 .then(res => res.json())
//                 .then(data => setProductList(data))
//                 .catch(err => console.error('Failed to load product list:', err));
//         }
//     }, [userId]);

//     const uniqueCategories = [...new Set(productList.map(p => p.category))];

//     // 🔍 Filter by search text
//     const filteredProducts = products.filter(p => {
//         const text = searchQuery.toLowerCase();
//         return (
//             p.category?.toLowerCase().includes(text) ||
//             p.subcategory?.toLowerCase().includes(text) ||
//             p.code?.toLowerCase().includes(text) ||
//             p.size?.toLowerCase().includes(text)
//         );
//     });

//     // 🔽 Sorting handler
//     const handleSort = (key) => {
//         let direction = "asc";
//         if (sortConfig.key === key && sortConfig.direction === "asc") {
//             direction = "desc";
//         }
//         setSortConfig({ key, direction });
//     };

//     // Apply sorting
//     const sortedProducts = [...filteredProducts].sort((a, b) => {
//         if (!sortConfig.key) return 0;
//         const x = a[sortConfig.key];
//         const y = b[sortConfig.key];
//         if (x < y) return sortConfig.direction === "asc" ? -1 : 1;
//         if (x > y) return sortConfig.direction === "asc" ? 1 : -1;
//         return 0;
//     });

//     // 📄 Pagination calculations
//     const indexOfLast = currentPage * rowsPerPage;
//     const indexOfFirst = indexOfLast - rowsPerPage;

//     const currentProducts = sortedProducts.slice(indexOfFirst, indexOfLast);

//     const totalPages = Math.ceil(sortedProducts.length / rowsPerPage);

//     const handleExportExcel = () => {
//         if (!filteredProducts || filteredProducts.length === 0) {
//             return alert("No data to export");
//         }

//         // 1️⃣ CSV headers matching table columns
//         const headers = ["S.No", "Category", "Subcategory", "Code", "Size", "Date", "Stock"];

//         // 2️⃣ Prepare CSV rows
//         const rows = filteredProducts.map((product, index) => [
//             index + 1,                   // S.No
//             `"${product.category}"`,     // Category
//             `"${product.subcategory}"`,  // Subcategory
//             `"${product.code}"`,         // Code
//             `"${product.size}"`,         // Size
//             product.date?.split("T")[0] || "", // Date (YYYY-MM-DD)
//             product.stock || 0           // Stock
//         ]);

//         // 3️⃣ Combine header + rows
//         const csvContent = [
//             headers.join(","),          // header row
//             ...rows.map(r => r.join(",")) // data rows
//         ].join("\n");

//         // 4️⃣ Create downloadable CSV link
//         const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
//         const url = URL.createObjectURL(blob);
//         const link = document.createElement("a");
//         link.href = url;
//         link.setAttribute("download", "products.csv");
//         document.body.appendChild(link);
//         link.click();
//         document.body.removeChild(link);
//     };

//     return (
//         <div style={{ fontFamily: "Arial, sans-serif", minHeight: "100vh", color: "#222", }}>
//             {/* TITLE */}
//             <div>
//                 <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: "10px", marginBottom: "15px", }}>
//                     <h3 style={{ display: "flex", alignItems: "center", gap: "8px", color: "#273179", margin: 0 }}><FaBoxOpen /> Product & Inventory Management</h3>
//                     <button onClick={() => { setShowForm(prev => !prev); setTimeout(() => formRef.current?.scrollIntoView({ behavior: "smooth" }), 100); }} style={{ display: "flex", alignItems: "center", gap: "6px", background: "#1976d2", color: "#fff", padding: "8px 14px", fontSize: "14px", fontWeight: "500", borderRadius: "20px", border: "none", cursor: "pointer", whiteSpace: "nowrap", }}><FaPlusCircle />{showForm ? "Close Form" : "Add Inventory"}</button>
//                 </div>
//                 {showForm && (
//                     <div ref={formRef} style={{ background: "#fff", padding: "12px", boxShadow: "0 2px 8px rgba(0,0,0,0.05)", borderRadius: "10px", marginBottom: "20px", }}>
//                         <form onSubmit={handleAddProduct} style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(160px, 1fr))", gap: "12px", }}>
//                             <select required value={selectedCategory} onChange={(e) => {
//                                 const cat = e.target.value;
//                                 setSelectedCategory(cat);
//                                 setSelectedSubcategory("");
//                                 setSelectedVariant(null);
//                                 setFormData(prev => ({ ...prev, category: cat, subcategory: "", code: "", size: "" }));
//                             }} style={{ padding: "10px", fontSize: "14px", border: "1px solid #ddd", borderRadius: "6px", width: "100%", height: "42px", boxSizing: "border-box", }}>
//                                 <option value="">Select Category</option>
//                                 {uniqueCategories.map((cat, i) => (
//                                     <option key={i} value={cat}>{cat}</option>
//                                 ))}
//                             </select>
//                             <select required value={selectedSubcategory} onChange={(e) => {
//                                 const sub = e.target.value;
//                                 setSelectedSubcategory(sub);
//                                 setSelectedVariant(null);
//                                 setFormData(prev => ({ ...prev, subcategory: sub, code: "", size: "" }));
//                             }} style={{ padding: "10px", fontSize: "14px", border: "1px solid #ddd", borderRadius: "6px", width: "100%", height: "42px", boxSizing: "border-box", }}>
//                                 <option value="">Select Subcategory</option>
//                                 {productList.filter(p => p.category === selectedCategory).map(p => (
//                                     <option key={p.id} value={p.subcategory}>{p.subcategory}</option>
//                                 ))}
//                             </select>
//                             <select required value={formData.code} onChange={(e) => {
//                                 const code = e.target.value;
//                                 const variants = productList.find(p => p.subcategory === selectedSubcategory)?.variants || [];
//                                 const variant = variants.find(v => v.code === code);
//                                 setSelectedVariant(variant || null);
//                                 setFormData(prev => ({ ...prev, code, size: variant?.size || "", variant_id: variant?.id || null }));
//                                 setAvailableSizes(variants.filter(v => v.code === code).map(v => v.size));
//                             }} style={{ padding: "10px", fontSize: "14px", border: "1px solid #ddd", borderRadius: "6px", width: "100%", height: "42px", boxSizing: "border-box", }}>
//                                 <option value="">Select Code</option>
//                                 {[...new Set(
//                                     (productList.find(p => p.subcategory === selectedSubcategory)?.variants || []).map(v => v.code)
//                                 )].map(code => (
//                                     <option key={code} value={code}>{code}</option>
//                                 ))}
//                             </select>
//                             <select required value={formData.size} onChange={(e) => {
//                                 const size = e.target.value;
//                                 const variants = productList.find(p => p.subcategory === selectedSubcategory)?.variants || [];
//                                 const variant = variants.find(v => v.code === formData.code && v.size === size);
//                                 setSelectedVariant(variant || null);
//                                 setFormData(prev => ({ ...prev, size, variant_id: variant?.id || null }));
//                             }} style={{ padding: "10px", fontSize: "14px", border: "1px solid #ddd", borderRadius: "6px", width: "100%", height: "42px", boxSizing: "border-box", }}>
//                                 <option value="">Select Size</option>
//                                 {availableSizes?.map((s, i) => (
//                                     <option key={i} value={s}>{s}</option>
//                                 ))}
//                             </select>
//                             <input type="date" required value={formData.date} onChange={(e) => setFormData(prev => ({ ...prev, date: e.target.value }))} style={{ padding: "10px", fontSize: "14px", border: "1px solid #ddd", borderRadius: "6px", width: "100%", height: "42px", boxSizing: "border-box", }} />
//                             <input type="number" required placeholder="Stock" value={formData.stock} onChange={(e) => setFormData(prev => ({ ...prev, stock: e.target.value }))} style={{ padding: "10px", fontSize: "14px", border: "1px solid #ddd", borderRadius: "6px", width: "100%", height: "42px", boxSizing: "border-box", }} />
//                             <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
//                                 <strong>Block</strong>
//                                 <Switch checked={block} onChange={(e) => setBlock(e.target.checked)} />
//                             </div>
//                             <button type="submit" style={{ gridColumn: "span 2", background: "#1976d2", color: "#fff", border: "none", borderRadius: "8px", padding: "10px", cursor: "pointer", fontWeight: 500, }}>{editingId ? "Update Inventory" : "Add Inventory"}</button>
//                         </form>
//                     </div>
//                 )}
//             </div>

//             <div style={{ boxShadow: "0 2px 8px rgba(0,0,0,0.05)", }}>
//                 <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "12px", gap: "12px" }}>
//                     <input type="text" placeholder="Search category, subcategory, code..." value={searchQuery} onChange={e => { setSearchQuery(e.target.value); setCurrentPage(1); }} style={{ flex: 1, padding: "6px 10px", borderRadius: "10px", border: "1px solid #ccc", maxWidth: "600px", }} />
//                     <button style={{ padding: "6px 12px", borderRadius: "5px", cursor: "pointer" }} onClick={handleExportExcel}>Export Excel</button>
//                 </div>
                
//                 <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
//                     {currentProducts.map((product) => (
//                         <div key={product.id} style={{ border: "1px solid #ddd", borderRadius: "10px", padding: "12px", background: "#fff", boxShadow: "0 2px 6px rgba(0,0,0,0.08)", }}>
//                             {/* ROW 1 */}
//                             <div style={{ display: "flex", justifyContent: "space-between", flexWrap: "wrap", marginBottom: "6px" }}>
//                                 <div><strong>Category:</strong> {product.category}</div>
//                                 <div><strong>Subcategory:</strong> {product.subcategory}</div>
//                             </div>

//                             {/* ROW 2 */}
//                             <div style={{ display: "flex", justifyContent: "space-between", flexWrap: "wrap", marginBottom: "6px" }}>
//                                 <div><strong>Code:</strong> {product.code}</div>
//                                 <div><strong>Size:</strong> {product.size}</div>
//                             </div>

//                             {/* ROW 3 */}
//                             <div style={{ display: "flex", justifyContent: "space-between", flexWrap: "wrap", marginBottom: "6px" }}>
//                                 <div><strong>Date:</strong> {product.date?.split("T")[0]}</div>
//                                 <div><strong>Stock:</strong> {product.stock}</div>
//                             </div>

//                             {/* ADMIN BLOCK & ACTIONS */}
//                             <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: "10px", paddingTop: "10px", borderTop: "1px solid #eee" }}>
//                                 {isAdmin ? (
//                                     <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
//                                         <strong>Block:</strong>
//                                         <Switch
//                                             checked={product.block === 1}
//                                             color="primary"
//                                             onChange={async (e) => {
//                                                 const newBlock = e.target.checked ? 1 : 0;
//                                                 try {
//                                                     await fetch(`https://cloudapi.emedhatechnologies.com/pages/api/api/inventory/block/${product.id}`, {
//                                                         method: 'PATCH',
//                                                         headers: { 'Content-Type': 'application/json' },
//                                                         body: JSON.stringify({ block: newBlock, updated_by: currentUserId }),
//                                                     });                                          
//                                                     setProducts(prev =>
//                                                         prev.map(p => p.id === product.id ? { ...p, block: newBlock } : p)
//                                                     );
//                                                 } catch (err) {
//                                                     console.error('Failed to update block:', err);
//                                                     alert('Failed to update block status');
//                                                 }
//                                             }}
//                                         />
//                                     </div>
//                                 ) : <div />}
//                                 <div style={{ display: "flex", gap: "12px" }}>
//                                     <button onClick={() => handleEdit(product)} style={{ color: "#02adf0", background: "none", border: "none", cursor: "pointer", fontSize: "16px" }}><FaEdit /></button>
//                                     <button style={{ color: "gray", opacity: 0.6, cursor: "not-allowed", background: "none", border: "none", fontSize: "16px" }} disabled><FaTrash /></button>
//                                 </div>
//                             </div>
//                         </div>
//                     ))}
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default InventoryMaster;


// import React, { useState, useEffect } from 'react';
// import { Plus, Search, Trash2, Edit3, X, FileSpreadsheet, Package } from 'lucide-react';

// // Initial data utilizing your precise structural taxonomy
// const initialInventory = [
//   { 
//     id: 'INV-001', 
//     category: 'DYED Series', 
//     subcategory: 'Ash Dyed Velvet Grey', 
//     code: '0005', 
//     size: '2.44X1.22', 
//     date: '2026-01-19', 
//     stock: 13, 
//     block: 'A1' 
//   },
//   { 
//     id: 'INV-002', 
//     category: 'Teak', 
//     subcategory: 'Teak Divine Noir Wood HZ', 
//     code: '0001', 
//     size: '2.44X1.22', 
//     date: '2026-01-20', 
//     stock: 120, 
//     block: 'B4' 
//   },
// ];

// const CATEGORIES = [
//   "Teak", "Standard Naturals", "DYED Series", "Smoked Series", 
//   "ECHITED SERIES", "Specials - D-ART COLLECTIONS", 
//   "Specials - HDBX", "Specials - Herringbone", 
//   "Specials - Edgewood", "Tan Wood Series"
// ];

// // Helper hook to handle desktop/mobile layouts purely with JS since inline styles don't support media queries
// function useWindowWidth() {
//   const [width, setWidth] = useState(typeof window !== 'undefined' ? window.innerWidth : 1024);
  
//   useEffect(() => {
//     const handleResize = () => setWidth(window.innerWidth);
//     window.addEventListener('resize', handleResize);
//     return () => window.removeEventListener('resize', handleResize);
//   }, []);
  
//   return width;
// }

//  const InventoryMaster = () => {
//   const [inventory, setInventory] = useState(initialInventory);
//   const [searchTerm, setSearchTerm] = useState('');
//   const [isModalOpen, setIsModalOpen] = useState(false);
  
//   const width = useWindowWidth();
//   const isMobile = width < 768; // md breakpoint equivalency

//   // Form State for Handling both Create & Update operations
//   const [editingId, setEditingId] = useState(null);
//   const [formData, setFormData] = useState({
//     category: '',
//     subcategory: '',
//     code: '',
//     size: '',
//     date: new Date().toISOString().split('T')[0],
//     stock: '',
//     block: ''
//   });

//   // Open Form Modal for New Entry
//   const handleOpenCreate = () => {
//     setEditingId(null);
//     setFormData({ category: '', subcategory: '', code: '', size: '', date: new Date().toISOString().split('T')[0], stock: '', block: '' });
//     setIsModalOpen(true);
//   };

//   // Open Form Modal for Editing Existing Entry
//   const handleOpenEdit = (item) => {
//     setEditingId(item.id);
//     setFormData({ ...item });
//     setIsModalOpen(true);
//   };

//   // Delete Action
//   const handleDelete = (id) => {
//     if (window.confirm("Are you sure you want to delete this stock item?")) {
//       setInventory(inventory.filter(item => item.id !== id));
//     }
//   };

//   // Form Submit (Handles Save & Update)
//   const handleSubmit = (e) => {
//     e.preventDefault();
//     if (!formData.category || !formData.subcategory || !formData.code) {
//       alert("Please fill out all required fields.");
//       return;
//     }

//     if (editingId) {
//       // Update Mode
//       setInventory(inventory.map(item => item.id === editingId ? { ...formData, stock: Number(formData.stock) } : item));
//     } else {
//       // Create Mode
//       const newItem = {
//         ...formData,
//         id: `INV-00${inventory.length + 1}`,
//         stock: Number(formData.stock) || 0
//       };
//       setInventory([...inventory, newItem]);
//     }
//     setIsModalOpen(false);
//   };

//   // Client-side Native Excel/CSV Engine
//   const exportToExcel = () => {
//     const headers = ['ID,Category,Subcategory,Code,Size,Date,Stock,Block\n'];
//     const rows = inventory.map(item => 
//       `"${item.id}","${item.category}","${item.subcategory}","${item.code}","${item.size}","${item.date}",${item.stock},"${item.block || ''}"`
//     );
//     const blob = new Blob([headers.concat(rows.join('\n'))], { type: 'text/csv;charset=utf-8;' });
//     const link = document.createElement("a");
//     link.href = URL.createObjectURL(blob);
//     link.setAttribute("download", `Inventory_Report_${new Date().toISOString().split('T')[0]}.csv`);
//     document.body.appendChild(link);
//     link.click();
//     document.body.removeChild(link);
//   };

//   // Search filter implementation
//   const filteredInventory = inventory.filter(item =>
//     item.category.toLowerCase().includes(searchTerm.toLowerCase()) ||
//     item.subcategory.toLowerCase().includes(searchTerm.toLowerCase()) ||
//     item.code.includes(searchTerm)
//   );

//   // Computed Values for Top Metric Highlights
//   const totalItems = filteredInventory.length;
//   const totalStock = filteredInventory.reduce((acc, item) => acc + item.stock, 0);
//   const lowStockAlerts = filteredInventory.filter(item => item.stock < 15).length;

//   return (
//     <div style={{
//       padding: isMobile ? '16px' : '32px',
//       display: 'flex',
//       flexDirection: 'column',
//       gap: '24px',
//       maxWidth: '1280px',
//       marginLeft: 'auto',
//       marginRight: 'auto',
//       backgroundColor: '#f9fafb',
//       minHeight: '1000vh',
//       fontFamily: 'system-ui, -apple-system, sans-serif'
//     }}>
      
//       {/* Header Panel */}
//       <div style={{
//         display: 'flex',
//         flexDirection: isMobile ? 'column' : 'row',
//         alignItems: isMobile ? 'flex-start' : 'center',
//         justifyContent: 'between',
//         justifyContent: 'space-between',
//         gap: '16px',
//         borderBottom: '1px solid #e5e7eb',
//         paddingBottom: '20px'
//       }}>
//         <div>
//           <h1 style={{ fontSize: isMobile ? '20px' : '24px', fontWeight: '700', color: '#111827', margin: 0, trackingTight: '-0.025em' }}>Product & Inventory Management</h1>
//           <p style={{ color: '#6b7280', fontSize: isMobile ? '12px' : '14px', margin: '4px 0 0 0' }}>Real-time tracking of logs, veneers, cuts, and stock statuses.</p>
//         </div>
//         <div style={{ display: 'flex', width: isMobile ? '100%' : 'auto', gap: '8px' }}>
//           <button 
//             onClick={exportToExcel}
//             style={{
//               flex: 1,
//               display: 'flex',
//               alignItems: 'center',
//               justifyContent: 'center',
//               gap: '8px',
//               padding: '8px 12px',
//               border: '1px solid #d1d5db',
//               color: '#374151',
//               backgroundColor: '#ffffff',
//               borderRadius: '8px',
//               fontWeight: '500',
//               fontSize: isMobile ? '12px' : '14px',
//               cursor: 'pointer',
//               boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)'
//             }}
//           >
//             <FileSpreadsheet style={{ width: '16px', height: '16px', color: '#16a34a' }} />
//             <span>Export Excel</span>
//           </button>
//           <button 
//             onClick={handleOpenCreate}
//             style={{
//               flex: 1,
//               display: 'flex',
//               alignItems: 'center',
//               justifyContent: 'center',
//               gap: '8px',
//               padding: '8px 12px',
//               backgroundColor: '#2563eb',
//               color: '#ffffff',
//               border: 'none',
//               borderRadius: '8px',
//               fontWeight: '500',
//               fontSize: isMobile ? '12px' : '14px',
//               cursor: 'pointer',
//               boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)'
//             }}
//           >
//             <Plus style={{ width: '16px', height: '16px' }} />
//             <span>Add Inventory</span>
//           </button>
//         </div>
//       </div>

//       {/* Metrics Dash */}
//       <div style={{
//         display: 'grid',
//         gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr 1fr',
//         gap: '16px'
//       }}>
//         <div style={{ backgroundColor: '#ffffff', border: '1px solid #e5e7eb', borderRadius: '12px', padding: '16px', boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)' }}>
//           <p style={{ color: '#6b7280', fontSize: '12px', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '0.05em', margin: '0 0 4px 0' }}>Unique Products</p>
//           <h3 style={{ fontSize: isMobile ? '20px' : '24px', fontWeight: '700', color: '#111827', margin: 0 }}>{totalItems}</h3>
//         </div>
//         <div style={{ backgroundColor: '#ffffff', border: '1px solid #e5e7eb', borderRadius: '12px', padding: '16px', boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)' }}>
//           <p style={{ color: '#6b7280', fontSize: '12px', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '0.05em', margin: '0 0 4px 0' }}>Total Stock Sheets</p>
//           <h3 style={{ fontSize: isMobile ? '20px' : '24px', fontWeight: '700', color: '#2563eb', margin: 0 }}>{totalStock} units</h3>
//         </div>
//         <div style={{ backgroundColor: '#ffffff', border: '1px solid #e5e7eb', borderRadius: '12px', padding: '16px', boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)' }}>
//           <p style={{ color: '#6b7280', fontSize: '12px', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '0.05em', margin: '0 0 4px 0' }}>Low Vol. Warnings</p>
//           <h3 style={{ fontSize: isMobile ? '20px' : '24px', fontWeight: '700', color: lowStockAlerts > 0 ? '#d97706' : '#111827', margin: 0 }}>{lowStockAlerts}</h3>
//         </div>
//       </div>

//       {/* Filter Row */}
//       <div style={{ backgroundColor: '#ffffff', border: '1px solid #e5e7eb', borderRadius: '12px', padding: '12px', boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)' }}>
//         <div style={{ position: 'relative', display: 'flex', alignItems: 'center' }}>
//           <Search style={{ position: 'absolute', left: '12px', width: '16px', height: '16px', color: '#9ca3af' }} />
//           <input
//             type="text"
//             placeholder="Search category, subcategory, or code..."
//             value={searchTerm}
//             onChange={(e) => setSearchTerm(e.target.value)}
//             style={{
//               width: '100%',
//               paddingLeft: '36px',
//               paddingRight: '16px',
//               paddingTop: '8px',
//               paddingBottom: '8px',
//               border: '1px solid #d1d5db',
//               borderRadius: '8px',
//               outline: 'none',
//               fontSize: isMobile ? '12px' : '14px',
//               boxSizing: 'border-box'
//             }}
//           />
//         </div>
//       </div>

//       {/* Dynamic Inventory Container */}
//       <div style={{ backgroundColor: '#ffffff', border: '1px solid #e5e7eb', borderRadius: '12px', boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)', overflow: 'hidden' }}>
        
//         {/* MOBILE VIEW (CARD VIEW) */}
//         {isMobile && (
//           <div style={{ display: 'flex', flexDirection: 'column' }}>
//             {filteredInventory.length === 0 ? (
//               <div style={{ padding: '24px', textAlign: 'center', color: '#9ca3af', fontSize: '12px' }}>No records found.</div>
//             ) : (
//               filteredInventory.map((item, index) => (
//                 <div key={item.id} style={{ 
//                   padding: '16px', 
//                   display: 'flex', 
//                   flexDirection: 'column', 
//                   gap: '12px',
//                   backgroundColor: '#ffffff',
//                   borderBottom: index !== filteredInventory.length - 1 ? '1px solid #e5e7eb' : 'none'
//                 }}>
//                   <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
//                     <div style={{ display: 'flex', flexDirection: 'column', gap: '2px' }}>
//                       <span style={{ fontSize: '10px', fontFamily: 'monospace', color: '#9ca3af', letterSpacing: '-0.025em' }}>{item.id}</span>
//                       <h4 style={{ fontSize: '14px', fontWeight: '700', color: '#111827', margin: 0 }}>{item.subcategory}</h4>
//                       <p style={{ fontSize: '12px', color: '#555555', margin: 0 }}>{item.category}</p>
//                     </div>
//                     <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
//                       <button 
//                         onClick={() => handleOpenEdit(item)}
//                         style={{ padding: '6px', border: 'none', background: 'none', color: '#6b7280', cursor: 'pointer' }}
//                       >
//                         <Edit3 style={{ width: '16px', height: '16px' }} />
//                       </button>
//                       <button 
//                         onClick={() => handleDelete(item.id)}
//                         style={{ padding: '6px', border: 'none', background: 'none', color: '#6b7280', cursor: 'pointer' }}
//                       >
//                         <Trash2 style={{ width: '16px', height: '16px' }} />
//                       </button>
//                     </div>
//                   </div>

//                   <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '8px', fontSize: '12px', borderTop: '1px solid #f3f4f6', paddingTop: '10px' }}>
//                     <div>
//                       <span style={{ color: '#9ca3af', display: 'block', fontSize: '10px', textTransform: 'uppercase' }}>Code</span>
//                       <span style={{ fontFamily: 'monospace', backgroundColor: '#f3f4f6', padding: '2px 4px', borderRadius: '4px', color: '#374151' }}>{item.code}</span>
//                     </div>
//                     <div>
//                       <span style={{ color: '#9ca3af', display: 'block', fontSize: '10px', textTransform: 'uppercase' }}>Size</span>
//                       <span style={{ color: '#374151', fontWeight: '500' }}>{item.size || 'N/A'}</span>
//                     </div>
//                     <div>
//                       <span style={{ color: '#9ca3af', display: 'block', fontSize: '10px', textTransform: 'uppercase' }}>Block</span>
//                       <span style={{ color: '#7e22ce', fontWeight: '700' }}>{item.block || '-'}</span>
//                     </div>
//                     <div>
//                       <span style={{ color: '#9ca3af', display: 'block', fontSize: '10px', textTransform: 'uppercase' }}>Stock Status</span>
//                       <span style={{ 
//                         display: 'inline-block', 
//                         padding: '2px 6px', 
//                         borderRadius: '4px', 
//                         fontSize: '11px', 
//                         fontWeight: '700',
//                         backgroundColor: item.stock > 50 ? '#f0fdf4' : item.stock >= 15 ? '#eff6ff' : '#fff1f2',
//                         color: item.stock > 50 ? '#15803d' : item.stock >= 15 ? '#1d4ed8' : '#be123c'
//                       }}>
//                         {item.stock} sheets
//                       </span>
//                     </div>
//                   </div>
//                 </div>
//               ))
//             )}
//           </div>
//         )}

//         {/* DESKTOP & TABLET VIEW */}
//         {!isMobile && (
//           <div style={{ width: '100%', overflowX: 'auto' }}>
//             <table style={{ width: '100%', textAlign: 'left', borderCollapse: 'collapse' }}>
//               <thead>
//                 <tr style={{ backgroundColor: 'rgba(249, 250, 251, 0.7)', borderBottom: '1px solid #e5e7eb' }}>
//                   <th style={{ padding: '12px 16px', fontSize: '12px', fontWeight: '600', color: '#4b5563', textTransform: 'uppercase' }}>Item ID</th>
//                   <th style={{ padding: '12px 16px', fontSize: '12px', fontWeight: '600', color: '#4b5563', textTransform: 'uppercase' }}>Category Hierarchy</th>
//                   <th style={{ padding: '12px 16px', fontSize: '12px', fontWeight: '600', color: '#4b5563', textTransform: 'uppercase' }}>Code</th>
//                   <th style={{ padding: '12px 16px', fontSize: '12px', fontWeight: '600', color: '#4b5563', textTransform: 'uppercase' }}>Dimension Size</th>
//                   <th style={{ padding: '12px 16px', fontSize: '12px', fontWeight: '600', color: '#4b5563', textTransform: 'uppercase' }}>Log Block</th>
//                   <th style={{ padding: '12px 16px', fontSize: '12px', fontWeight: '600', color: '#4b5563', textTransform: 'uppercase' }}>Stock Count</th>
//                   <th style={{ padding: '12px 16px', fontSize: '12px', fontWeight: '600', color: '#4b5563', textTransform: 'uppercase', textAlign: 'right' }}>Actions</th>
//                 </tr>
//               </thead>
//               <tbody style={{ display: 'table-row-group' }}>
//                 {filteredInventory.length === 0 ? (
//                   <tr>
//                     <td colSpan="7" style={{ textAlign: 'center', padding: '32px', color: '#9ca3af', fontSize: '14px' }}>No inventory records found.</td>
//                   </tr>
//                 ) : (
//                   filteredInventory.map((item) => (
//                     <tr key={item.id} style={{ borderBottom: '1px solid #f3f4f6' }}>
//                       <td style={{ padding: '14px 16px', fontSize: '14px', fontWeight: '500', color: '#6b7280' }}>{item.id}</td>
//                       <td style={{ padding: '14px 16px' }}>
//                         <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
//                           <div style={{ width: '32px', height: '32px', backgroundColor: '#eff6ff', borderRadius: '8px', display: 'flex', alignItems: 'center', justifycontent: 'center', justifyContent: 'center', flexShrink: 0 }}>
//                             <Package style={{ width: '16px', height: '16px', color: '#2563eb' }} />
//                           </div>
//                           <div>
//                             <div style={{ fontSize: '14px', fontWeight: '600', color: '#111827' }}>{item.subcategory}</div>
//                             <div style={{ fontSize: '12px', color: '#9ca3af' }}>{item.category}</div>
//                           </div>
//                         </div>
//                       </td>
//                       <td style={{ padding: '14px 16px', fontSize: '14px', color: '#374151', fontFamily: 'monospace' }}>
//                         <span style={{ backgroundColor: '#f3f4f6', padding: '4px 8px', borderRadius: '4px' }}>{item.code}</span>
//                       </td>
//                       <td style={{ padding: '14px 16px', fontSize: '14px', color: '#4b5563' }}>{item.size || 'N/A'}</td>
//                       <td style={{ padding: '14px 16px', fontSize: '14px', fontWeight: '500', color: '#7e22ce' }}>{item.block || '-'}</td>
//                       <td style={{ padding: '14px 16px' }}>
//                         <span style={{ 
//                           padding: '4px 8px', 
//                           borderRadius: '4px', 
//                           fontSize: '12px', 
//                           fontWeight: '700',
//                           backgroundColor: item.stock > 50 ? '#f0fdf4' : item.stock >= 15 ? '#eff6ff' : '#fff1f2',
//                           color: item.stock > 50 ? '#15803d' : item.stock >= 15 ? '#1d4ed8' : '#be123c'
//                         }}>
//                           {item.stock} sheets
//                         </span>
//                       </td>
//                       <td style={{ padding: '14px 16px', textAlign: 'right' }}>
//                         <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '8px' }}>
//                           <button 
//                             onClick={() => handleOpenEdit(item)}
//                             style={{ padding: '6px', border: 'none', background: 'none', color: '#6b7280', cursor: 'pointer' }}
//                           >
//                             <Edit3 style={{ width: '16px', height: '16px' }} />
//                           </button>
//                           <button 
//                             onClick={() => handleDelete(item.id)}
//                             style={{ padding: '6px', border: 'none', background: 'none', color: '#6b7280', cursor: 'pointer' }}
//                           >
//                             <Trash2 style={{ width: '16px', height: '16px' }} />
//                           </button>
//                         </div>
//                       </td>
//                     </tr>
//                   ))
//                 )}
//               </tbody>
//             </table>
//           </div>
//         )}

//         {/* Dynamic Entry Summary Bar */}
//         <div style={{ padding: '12px', borderTop: '1px solid #f3f4f6', backgroundColor: 'rgba(249, 250, 251, 0.3)', display: 'flex', justifyContent: 'space-between', alignItems: 'center', fontSize: '11px', color: '#6b7280' }}>
//           <span>Records: {filteredInventory.length} of {inventory.length}</span>
//           <span>Page 1 / 1</span>
//         </div>
//       </div>

//       {/* CRUD Overlay Form Modal */}
//       {isModalOpen && (
//         <div style={{ 
//           position: 'fixed', 
//           top: 0, left: 0, right: 0, bottom: 0, 
//           zIndex: 50, 
//           display: 'flex', 
//           alignItems: 'center', 
//           justifyContent: 'center', 
//           padding: '12px', 
//           backgroundColor: 'rgba(0, 0, 0, 0.4)',
//           backdropFilter: 'blur(4px)'
//         }}>
//           <div style={{ 
//             backgroundColor: '#ffffff', 
//             borderRadius: '12px', 
//             boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1)', 
//             width: '100%', 
//             maxWidth: '448px', 
//             overflow: 'hidden', 
//             display: 'flex', 
//             flexDirection: 'column', 
//             maxHeight: '95vh' 
//           }}>
            
//             <div style={{ padding: '14px 20px', borderBottom: '1px solid #e5e7eb', display: 'flex', alignItems: 'center', justifyContent: 'space-between', backgroundColor: '#f9fafb' }}>
//               <h2 style={{ fontSize: '16px', fontWeight: '700', color: '#111827', margin: 0 }}>
//                 {editingId ? 'Modify Record' : 'Add New Asset'}
//               </h2>
//               <button 
//                 onClick={() => setIsModalOpen(false)}
//                 style={{ padding: '4px', color: '#9ca3af', border: 'none', background: 'none', cursor: 'pointer', borderRadius: '4px' }}
//               >
//                 <X style={{ width: '16px', height: '16px' }} />
//               </button>
//             </div>

//             <form onSubmit={handleSubmit} style={{ padding: '20px', display: 'flex', flexDirection: 'column', gap: '14px', overflowY: 'auto', flex: 1, fontSize: isMobile ? '12px' : '14px', boxSizing: 'border-box' }}>
//               <div>
//                 <label style={{ display: 'block', fontSize: '11px', fontWeight: '600', color: '#4b5563', marginBottom: '4px', textTransform: 'uppercase', letterSpacing: '0.05em' }}>Select Category *</label>
//                 <select 
//                   value={formData.category} 
//                   onChange={(e) => setFormData({...formData, category: e.target.value})}
//                   style={{ width: '100%', border: '1px solid #d1d5db', borderRadius: '8px', padding: '8px', backgroundColor: '#ffffff', outline: 'none', boxSizing: 'border-box' }}
//                   required
//                 >
//                   <option value="">-- Choose Category --</option>
//                   {CATEGORIES.map(cat => <option key={cat} value={cat}>{cat}</option>)}
//                 </select>
//               </div>

//               <div>
//                 <label style={{ display: 'block', fontSize: '11px', fontWeight: '600', color: '#4b5563', marginBottom: '4px', textTransform: 'uppercase', letterSpacing: '0.05em' }}>Subcategory / Variant Name *</label>
//                 <input 
//                   type="text" 
//                   placeholder="e.g., Ash Dyed Velvet Grey"
//                   value={formData.subcategory} 
//                   onChange={(e) => setFormData({...formData, subcategory: e.target.value})}
//                   style={{ width: '100%', border: '1px solid #d1d5db', borderRadius: '8px', padding: '8px', outline: 'none', boxSizing: 'border-box' }}
//                   required
//                 />
//               </div>

//               <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' }}>
//                 <div>
//                   <label style={{ display: 'block', fontSize: '11px', fontWeight: '600', color: '#4b5563', marginBottom: '4px', textTransform: 'uppercase', letterSpacing: '0.05em' }}>Select Code *</label>
//                   <input 
//                     type="text" 
//                     placeholder="e.g., 0005"
//                     value={formData.code} 
//                     onChange={(e) => setFormData({...formData, code: e.target.value})}
//                     style={{ width: '100%', border: '1px solid #d1d5db', borderRadius: '8px', padding: '8px', outline: 'none', boxSizing: 'border-box' }}
//                     required
//                   />
//                 </div>
//                 <div>
//                   <label style={{ display: 'block', fontSize: '11px', fontWeight: '600', color: '#4b5563', marginBottom: '4px', textTransform: 'uppercase', letterSpacing: '0.05em' }}>Select Size</label>
//                   <input 
//                     type="text" 
//                     placeholder="e.g., 2.44X1.22"
//                     value={formData.size} 
//                     onChange={(e) => setFormData({...formData, size: e.target.value})}
//                     style={{ width: '100%', border: '1px solid #d1d5db', borderRadius: '8px', padding: '8px', outline: 'none', boxSizing: 'border-box' }}
//                   />
//                 </div>
//               </div>

//               <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' }}>
//                 <div>
//                   <label style={{ display: 'block', fontSize: '11px', fontWeight: '600', color: '#4b5563', marginBottom: '4px', textTransform: 'uppercase', letterSpacing: '0.05em' }}>Stock Count *</label>
//                   <input 
//                     type="number" 
//                     placeholder="0"
//                     min="0"
//                     value={formData.stock} 
//                     onChange={(e) => setFormData({...formData, stock: e.target.value})}
//                     style={{ width: '100%', border: '1px solid #d1d5db', borderRadius: '8px', padding: '8px', outline: 'none', boxSizing: 'border-box' }}
//                     required
//                   />
//                 </div>
//                 <div>
//                   <label style={{ display: 'block', fontSize: '11px', fontWeight: '600', color: '#4b5563', marginBottom: '4px', textTransform: 'uppercase', letterSpacing: '0.05em' }}>Block Location</label>
//                   <input 
//                     type="text" 
//                     placeholder="e.g., Block A"
//                     value={formData.block} 
//                     onChange={(e) => setFormData({...formData, block: e.target.value})}
//                     style={{ width: '100%', border: '1px solid #d1d5db', borderRadius: '8px', padding: '8px', outline: 'none', boxSizing: 'border-box' }}
//                   />
//                 </div>
//               </div>

//               <div>
//                 <label style={{ display: 'block', fontSize: '11px', fontWeight: '600', color: '#4b5563', marginBottom: '4px', textTransform: 'uppercase', letterSpacing: '0.05em' }}>Log Date</label>
//                 <input 
//                   type="date" 
//                   value={formData.date} 
//                   onChange={(e) => setFormData({...formData, date: e.target.value})}
//                   style={{ width: '100%', border: '1px solid #d1d5db', borderRadius: '8px', padding: '8px', outline: 'none', boxSizing: 'border-box' }}
//                 />
//               </div>

//               <div style={{ paddingTop: '12px', borderTop: '1px solid #e5e7eb', display: 'flex', justifyContent: 'flex-end', gap: '8px' }}>
//                 <button 
//                   type="button"
//                   onClick={() => setIsModalOpen(false)}
//                   style={{ padding: '8px 16px', border: '1px solid #d1d5db', borderRadius: '8px', color: '#374151', backgroundColor: '#ffffff', cursor: 'pointer' }}
//                 >
//                   Close Form
//                 </button>
//                 <button 
//                   type="submit"
//                   style={{ padding: '8px 16px', backgroundColor: '#2563eb', color: '#ffffff', border: 'none', borderRadius: '8px', fontWeight: '500', cursor: 'pointer' }}
//                 >
//                   Save Entry
//                 </button>
//               </div>
//             </form>

//           </div>
//         </div>
//       )}
//     </div>
//   );
// }

// export default InventoryMaster;